import { Component, OnInit } from '@angular/core';
import { Toast } from 'app/shared/toast/toast';
import { MicrosoftAuth } from "./onedrive.type";
import { setCookie } from "app/shared/cookie";

@Component({
   selector: 'app-oauth-callback',
   template: '',
})
export class CallbackComponent implements OnInit {
    errorMessage: any;

    constructor(private toast: Toast) {}

    ngOnInit() {
        const url = window.location.href.match(/\=([\S\s]*?)\&/);
        this.onAuthCallback();
        window.opener.postMessage({ message: 'deliverResult', result: true }, url);
        window.close();
    }

    onAuthCallback() {
        const authInfo = this.getAuthInfoFromUrl();
        if (!authInfo) {
            return;
        }
        
        const access_token = authInfo['access_token'];
        const action = localStorage.getItem('onedrive_action');

        if (access_token) {
            if (action === 'signin') {
                localStorage.setItem('onedrive_callback', 'true');
            }
        }
    }

    getAuthInfoFromUrl() {
        if (window.location.hash) {
            const authResponse = window.location.hash.substring(1);
            const authInfo: MicrosoftAuth = JSON.parse(
                '{' + authResponse.replace(/([^=]+)=([^&]+)&?/g, '"$1":"$2",').slice(0, -1) + '}',
                function(key, value) { return key === '' ? value : decodeURIComponent(value); });
            
            const access_token = authInfo['access_token'];
            if(access_token) {
                window.localStorage.setItem('access_token', access_token);
                this.setOneDriveCookie(access_token, parseInt(authInfo?.expires_in, 10), "odauth");
            }

            const id_token = authInfo['id_token'];
            if(id_token) {
                window.localStorage.setItem('id_token', id_token);
                this.setOneDriveCookie(id_token, parseInt(authInfo?.expires_in, 10), "odidauth");
            }

            return authInfo;
        } else {
            this.toast.error('failed to receive auth token');
        }
    }

   setOneDriveCookie(token: string, expiresInSeconds: number, cookieName: string) {
      const expDateTime = new Date();
      expDateTime.setTime(expDateTime.getTime() + expiresInSeconds * 1000);
      
      const isSecure = document.location.protocol?.toLowerCase() === "https:";
      setCookie(cookieName, token, expDateTime, isSecure);
   }

}
